import { Routes, Route, Navigate } from 'react-router-dom';
import { ReportPage } from './pages/ReportPage';
import { PrintReportPage } from './pages/PrintReportPage';
import { NotFoundPage } from './pages/NotFoundPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<NotFoundPage />} />
      {/* Print route for the headless PDF renderer (token-authenticated). */}
      <Route path="/:slug/print" element={<PrintReportPage />} />
      <Route path="/:slug" element={<ReportPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
